export const getDecimals = ({ value }: { value: number | string }) =>
  // safe-by-includes-check: split('.')[1] is defined when includes('.') is true
  String(value).includes('.') ? String(value).split('.')[1]!.length : 0;
